import { render } from "./SustainabilityReport2024.vue?vue&type=template&id=23b67db1"
import script from "./SustainabilityReport2024.vue?vue&type=script&lang=js"
export * from "./SustainabilityReport2024.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__